<div class="flex flex-col">
  @if (showProgressBar()) {
    <div class="flex flex-wrap items-center gap-2">
      <span class="capitalize">{{ kpi().name }}</span>
      <progress-bar
        class="flex-1"
        [progress]="kpi().percentage">
      </progress-bar>
    </div>
  }
  @if (kpi().showDetails) {
    <div class="@container/kpis-details text-[#A2A2A2]">
      <div class="flex w-full flex-col items-start justify-between @sm:flex-row">
        @for (detail of kpi().details; track $index) {
          <p>
            {{ detail.title }}: <span class="font-bold">{{ detail.description }}</span>
          </p>
        }
      </div>
    </div>
  }
</div>
